import { Link, useLocation } from "react-router-dom";
import { MASTER_NAV } from "../navigation/masterCatalog";
import { filterMasterItems } from "../navigation/access";
import { activeNavigationItem } from "../navigation/activeItem";
import useSidebarScroll from "../hooks/useSidebarScroll";

export default function MasterNavigation({ has, scrollScope }) {
  const { pathname } = useLocation();
  const groups = MASTER_NAV.map(group => ({ ...group, items: filterMasterItems(group.items, has) }));
  const active = activeNavigationItem(groups, pathname);
  const scroll = useSidebarScroll(scrollScope, `${pathname}:${active || ""}`);
  return (
    <nav {...scroll} aria-label="Platform navigation" className="flex-1 py-2 overflow-y-auto thin-scroll">
      {groups.map((g, gi) => {
        const items = g.items;
        if (!items.length) return null;
        return (
          <div key={gi} className="mb-1">
            {g.section && (
              <div className="hidden lg:block px-5 pt-3 pb-1 font-mono text-[9px] tracking-[0.2em] uppercase text-slate-500">
                {g.section}
              </div>
            )}
            {items.map((n) => {
              const Icon = n.icon;
              return (
                <Link
                  key={n.to}
                  to={n.to}
                  aria-current={active === n.to ? "page" : undefined}
                  data-testid={`master-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                  className={
                    `flex items-center gap-3 px-3 lg:px-5 h-10 text-sm transition-colors border-l-2 ${
                      active === n.to
                        ? "border-cyan-400 bg-cyan-400/10 text-slate-50 font-semibold"
                        : "border-transparent text-slate-400 hover:bg-slate-800/60 hover:text-slate-100"
                    }`
                  }
                >
                  <Icon className="text-lg shrink-0" />
                  <span className="hidden lg:inline truncate">{n.label}</span>
                </Link>
              );
            })}
          </div>
        );
      })}
    </nav>
  );
}
